const offCanvas = function() {

    const loadOffCanvasGlobal = (ev) => {
        ev.stopPropagation();
        let e               = ev.currentTarget;
        const plImage       = e.getAttribute('data-image');
        const plTitle       = e.getAttribute('data-title');
        const plsubTitle    = e.getAttribute('data-subtitle');
        const plCountry     = e.getAttribute('data-country');
        const plText        = e.getAttribute('data-text');
        const plKeynote     = e.getAttribute('data-keynote');

        Swal.fire({
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            background:'transparent',
            width : '200px',
            didOpen: () => {
                Swal.showLoading()
            }
        });

        // alimentando offCavnas
        document.getElementById('palestrante-image').setAttribute('src',plImage);
        document.getElementById('palestrante-title').innerHTML=plTitle;
        document.getElementById('palestrante-subtitle').innerHTML=plsubTitle;
        document.getElementById('palestrante-country').innerHTML=plCountry;
        document.getElementById('palestrante-text').innerHTML=plText;
        document.getElementById('palestrante-keynote').innerHTML=plKeynote;

        const myOffcanvas   = document.getElementById('offcanvasGlobal')
        let bsOffcanvas     = new bootstrap.Offcanvas(myOffcanvas)

        setTimeout(() => {
            Swal.close()
            bsOffcanvas.show()
        }, 600);
    }

    return {

        init : function () {

            document.querySelectorAll('.loadOffCanvasasContent').forEach((el) => {
                el.addEventListener('click', loadOffCanvasGlobal)
            })
        }

    }

}();

export default offCanvas;
